import { PropsWithChildren } from 'react';

type PermissionsTableProps = PropsWithChildren<{
  title: string;
  headers: string[];
}>;

/**
 * Titled, bordered table used on the prerequisites step to lay out the
 * permissions the Qodo user needs. Rows are passed as `children`.
 */
export const PermissionsTable = ({
  title,
  headers,
  children,
}: PermissionsTableProps) => (
  <div className="flex flex-col gap-2">
    <span className="text-sm font-medium text-text-general-neutral-strong">
      {title}
    </span>
    <table className="w-full border-collapse text-left text-xs">
      <thead>
        <tr>
          {headers.map((header) => (
            <th
              key={header}
              className="border border-border-bg-neutral px-3 py-2 font-medium text-text-general-neutral-mid"
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  </div>
);
